import { CreateGatewayCustomer } from '../../purchases/dto/create-customer.dto'

export class CreateGatewayCard {
    number: string
    name: string
    expirationMonth: string
    expirationYear: string
    securityCode: string
    brand: string
}
